import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Spinner,
  Table,
  Toast,
  ToastContainer,
} from "react-bootstrap";
import { isAuthenticated } from "../../auth/helper/auth";
import { API } from "../../backend";
import { CategoryT } from "../../types/model";
import {
  deleteHttpHandler,
  getHttpHandler,
  postHttpHandler,
  putHttpHandler,
} from "../../utils/httpHandler";
import { ReactComponent as AddImg } from "../../assets/add.svg";
import { ReactComponent as ManageCategoryImg } from "../../assets/manageCategory.svg";
import { ReactComponent as DeleteImg } from "../../assets/delete.svg";
import { ReactComponent as EditImg } from "../../assets/edit.svg";
import "./ManageCategory.css";

const ManageCategory = () => {
  const [categories, setCategories] = useState<CategoryT[]>([]);
  const [categoryLoading, setCategoryLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [show, setShow] = useState<boolean>(false);
  const [delCatId, setDelCatId] = useState<string>("");

  const getAllCategories = async () => {
    setCategoryLoading(true);
    try {
      const allCategories: CategoryT[] = await getHttpHandler({
        url: `${API}/categories`,
      });
      setCategories(allCategories);
      setCategoryLoading(false);
    } catch (error) {
      setCategoryLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  const addCategory = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();

    let categoryName = window.prompt("Enter a Category Name");
    if (!categoryName) return;

    try {
      const addCat = await postHttpHandler({
        url: `${API}/category/create/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated().token,
        body: { name: categoryName },
      });
      if (addCat.category._id) {
        getAllCategories();
        setMessage(`${addCat.category?.name} created successfully!!`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const deleteCategory = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    try {
      const del = await deleteHttpHandler({
        url: `${API}/category/${delCatId}/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated().token,
      });
      setMessage("Deleted Category");
      setShow(false);
      setDelCatId("");
      getAllCategories();
    } catch (error) {
      console.error(error);
    }
  };

  const updateCategory = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    category: CategoryT
  ) => {
    e.preventDefault();
    let categoryName = window.prompt("Update the category", category.name);

    if (!categoryName) return;

    try {
      const updateCate = await putHttpHandler({
        url: `${API}/category/${category._id}/${isAuthenticated()?.user._id}`,
        idToken: isAuthenticated().token,
        body: { name: categoryName },
      });
      if (updateCate?._id) {
        getAllCategories();
        setMessage(`${updateCate?.name} updated successfully!!`);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="manage-category">
      <Modal
        className="manage-category-modal"
        show={show}
        onHide={() => {
          setShow(false);
          setDelCatId("");
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Category</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure that you want to delete this category?
        </Modal.Body>
        <Modal.Footer>
          <button
            className="action-btn white-action-btn"
            onClick={(e) => {
              e.preventDefault();
              setShow(false);
              setDelCatId("");
            }}
          >
            Cancel
          </button>
          <button className="action-btn" onClick={deleteCategory}>
            Delete
          </button>
        </Modal.Footer>
      </Modal>
      <div className="header-div">
        <h1 className="title">
          <ManageCategoryImg className="title-icon" />
          Manage Categories
        </h1>
        <div className="manage-btns">
          <button onClick={addCategory}>
            Add New Category <AddImg />
          </button>
        </div>
      </div>

      <ToastContainer position="top-end">
        <Toast
          show={!!message}
          onClose={() => setMessage("")}
          autohide
          delay={2000}
        >
          <Toast.Header closeButton={false}>{message}</Toast.Header>
        </Toast>
      </ToastContainer>
      {categoryLoading ? (
        <Spinner animation="border" />
      ) : (
        <Table responsive borderless className="category-table">
          <thead>
            <tr>
              <th>Cateogry Name</th>
              <th>Delete</th>
              <th>Edit</th>
            </tr>
          </thead>
          <tbody>
            {categories?.map((category) => (
              <tr key={category._id}>
                <td>{category.name}</td>
                <td>
                  <button
                    className="action-btn delete-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      setShow(true);
                      setDelCatId(category._id);
                    }}
                  >
                    Delete <DeleteImg />
                  </button>
                </td>
                <td>
                  <button
                    className="action-btn"
                    onClick={(
                      e: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ) => updateCategory(e, category)}
                  >
                    Update <EditImg />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default ManageCategory;
